import { SnackbarOrigin } from "@material-ui/core/Snackbar";
import MuiSnackbar from "@material-ui/core/Snackbar/Snackbar";
import { createStyles, Theme, withStyles, WithStyles } from "@material-ui/core/styles";
import React from "react";
import { SnackbarVariants } from "./constants";
import { SnackbarMessageContent } from "./snackbar-messages";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      // Just above Snackbar Notifications
      zIndex: 1401,
    },
  });

interface SnackbarMessageProps extends WithStyles<typeof styles> {
  message?: string | React.ReactNode;
  messageKey?: string | number;
  messageOptions?: {
    variant?: SnackbarVariants;
    anchorOrigin?: SnackbarOrigin;
    autoHideDuration?: number | null;
  };
}

interface SnackbarMessageState {
  open: boolean;
}

export const SnackbarMessageComponent = class extends React.Component<SnackbarMessageProps, SnackbarMessageState> {
  constructor(props: any) {
    super(props);

    this.state = {
      open: false,
    };
  }

  public render() {
    const { message, messageOptions = {}, classes } = this.props;
    const { open } = this.state;

    const variant = messageOptions.variant || "info";
    const anchorOrigin =
      messageOptions.anchorOrigin || ({ vertical: "bottom", horizontal: "center" } as SnackbarOrigin);
    const autoHideDuration = messageOptions.autoHideDuration;

    return (
      <MuiSnackbar
        anchorOrigin={anchorOrigin}
        open={open}
        autoHideDuration={autoHideDuration}
        onClose={this.handleMessageClose}
        className={classes.root}
      >
        <SnackbarMessageContent variant={variant} message={message} onClose={this.handleMessageClose} />
      </MuiSnackbar>
    );
  }

  public componentDidUpdate(prevProps: SnackbarMessageProps, prevState: SnackbarMessageState) {
    const { messageKey: prevMessageKey } = prevProps;
    const { messageKey } = this.props;

    if (prevMessageKey !== messageKey) {
      this.setState({ open: true });
    }
  }

  public handleMessageClose = (event: any, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ open: false });
  };
};

export const SnackbarMessage = withStyles(styles)(SnackbarMessageComponent);
